'use client';

import { c as _c } from "react/compiler-runtime";
import * as SwitchPrimitive from '@radix-ui/react-switch';
import * as React from 'react';
import { cn } from '../../utils/cn';
function Switch(t0) {
  const $ = _c(9);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("has-[[data-state=checked]]:bg-primary has-[[data-state=unchecked]]:bg-input hover:has-[[data-state=unchecked]]:bg-input/80 focus-visible:border-ring focus-visible:ring-ring peer inline-flex h-[20px] w-8 shrink-0 cursor-pointer items-center rounded-full border border-transparent p-[3px] shadow-xs transition-all outline-none focus-visible:ring-[2px] disabled:cursor-not-allowed disabled:opacity-50 hover:has-[[data-state=checked]]:brightness-105", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <SwitchPrimitive.Thumb data-slot="switch-thumb" className={cn("bg-primary data-[state=checked]:bg-primary-foreground dark:data-[state=unchecked]:bg-primary dark:data-[state=checked]:bg-primary-foreground pointer-events-none block size-3.5 rounded-full ring-0 transition-transform data-[state=checked]:translate-x-[calc(100%-3px)] data-[state=unchecked]:translate-x-0")} />;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== props || $[7] !== t1) {
    t3 = <SwitchPrimitive.Root data-slot="switch" className={t1} {...props}>{t2}</SwitchPrimitive.Root>;
    $[6] = props;
    $[7] = t1;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}
export { Switch };